// Seeded mock data for the entire admin operations dashboard.
// Deterministic-ish — uses a small LCG so refreshes look consistent.

let _seed = 7;
const rand = () => {
  _seed = (_seed * 9301 + 49297) % 233280;
  return _seed / 233280;
};
const pick = (arr) => arr[Math.floor(rand() * arr.length)];
const rint = (min, max) => Math.floor(rand() * (max - min + 1)) + min;
const choice = (arr, n) => {
  const c = [...arr].sort(() => rand() - 0.5);
  return c.slice(0, n);
};

const NIGERIAN_FIRST_NAMES = [
  "Adaeze", "Chinedu", "Tunde", "Femi", "Ngozi", "Bola", "Sade", "Kelechi",
  "Aisha", "Yusuf", "Funke", "Obi", "Ifeoma", "Musa", "Halima", "Emeka",
  "Zainab", "Olumide", "Chioma", "Babatunde", "Folake", "Ibrahim", "Amina",
  "Segun", "Nkechi", "Hassan", "Oluwaseun", "Ramatu", "Kachi", "Damilola",
];
const NIGERIAN_LAST_NAMES = [
  "Okafor", "Adebayo", "Eze", "Obi", "Bello", "Adekunle", "Olawale", "Yakubu",
  "Mohammed", "Aliyu", "Ogundimu", "Okeke", "Adesanya", "Ibrahim", "Sani",
  "Onyekachi", "Adigun", "Lawal", "Akinwale", "Nwosu",
];
const SHOP_NAMES = [
  "Sultana Enterprise", "Bright Star Mart", "Mama K Provisions", "Zion Cosmetics",
  "Faith Mini Mart", "Golden Touch Stores", "Olu's Pharmacy", "Akin Wholesale",
  "Iya Bola Foods", "Sabon Gari Traders", "Chika Beauty Hub", "Tasty Bites Kiosk",
  "Hassan Electronics", "Mama Put Restaurant", "Lagos Style Boutique", "Eko Hardware",
  "Abuja Fresh Mart", "Kano Textiles", "Port Harcourt Auto", "Ibadan Provisions",
  "Sunrise Phones", "Royal Tailors", "Green Leaf Grocers", "Pearl Cosmetics",
  "Sokoto Spices", "Enugu Bookshop", "Calabar Seafood", "Jos Tiles & Sanitary",
  "Aba Fashion House", "Warri Mini Mart", "Ogbomosho Foods", "Onitsha Market Hub",
  "Kaduna General Store", "Maiduguri Phones", "Benin Electronics", "Owerri Pharmacy",
  "Lokoja Trading Co", "Akure Mart", "Yola Boutique", "Asaba Provisions",
];
const LOCATIONS = [
  "Lagos, LG", "Abuja, FCT", "Kano, KN", "Ibadan, OY", "Port Harcourt, RV",
  "Kaduna, KD", "Benin City, ED", "Onitsha, AN", "Aba, AB", "Jos, PL",
  "Ilorin, KW", "Warri, DE", "Enugu, EN", "Calabar, CR", "Sokoto, SO",
  "Akure, ON", "Yola, AD", "Owerri, IM", "Maiduguri, BO", "Asaba, DE",
];
const TERRITORIES = ["Lagos Mainland", "Lagos Island", "Abuja Central", "Kano North", "Port Harcourt", "Ibadan", "Kaduna", "Enugu", "Benin"];

const PLANS = [
  { id: "solo", name: "Solo", price: 2000, currency: "NGN", limits: { branches: 1, staff: 1, products: 500 }, color: "#A7F3D0" },
  { id: "starter", name: "Starter", price: 3500, currency: "NGN", limits: { branches: 1, staff: 3, products: 1000 }, color: "#BAE6FD" },
  { id: "growth", name: "Growth", price: 6500, currency: "NGN", limits: { branches: 3, staff: 8, products: 5000 }, color: "#C4B5FD" },
  { id: "scale", name: "Scale", price: 10000, currency: "NGN", limits: { branches: 10, staff: 20, products: 20000 }, color: "#FDE047" },
];

const STATUSES = ["active", "trial", "expired", "suspended"];
const SYNC_STATUSES = ["healthy", "healthy", "healthy", "warning", "failed"];
const LANGUAGES = ["English", "Hausa", "Yoruba", "Igbo", "Pidgin"];

const TICKET_CATEGORIES = ["Sync issue", "Payment issue", "Login issue", "Inventory issue", "Staff issue", "Branch issue", "Analytics issue", "Notification issue", "Other"];
const TICKET_PRIORITIES = ["Low", "Medium", "High", "Urgent"];
const TICKET_STATUSES = ["Open", "In Progress", "Resolved", "Closed"];

const LEAD_STATUSES = ["New", "Contacted", "Demo Done", "Interested", "Paid", "Not Interested", "Follow Up"];

const AVATARS = [
  "https://images.unsplash.com/photo-1666867540898-aaa1993ffabc?w=128&h=128&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1614023342667-6f060e9d1e04?w=128&h=128&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1616805765352-beedbad46b2a?w=128&h=128&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1563132337-f159f484226c?w=128&h=128&fit=crop&crop=faces",
];

const id = (p) => `${p}_${Math.random().toString(36).slice(2, 9)}`;

const fullName = () => `${pick(NIGERIAN_FIRST_NAMES)} ${pick(NIGERIAN_LAST_NAMES)}`;
const phone = () => `+234 ${rint(700, 909)} ${rint(100, 999)} ${rint(1000, 9999)}`;
const daysAgo = (d) => {
  const dt = new Date();
  dt.setDate(dt.getDate() - d);
  return dt.toISOString();
};
const daysFromNow = (d) => {
  const dt = new Date();
  dt.setDate(dt.getDate() + d);
  return dt.toISOString();
};

// ---- Build seed ----
function buildShops(n = 42) {
  const shops = [];
  for (let i = 0; i < n; i++) {
    const owner = {
      id: id("usr"),
      name: fullName(),
      phone: phone(),
      email: `${pick(NIGERIAN_FIRST_NAMES).toLowerCase()}.${pick(NIGERIAN_LAST_NAMES).toLowerCase()}@mail.com`,
      avatar: pick(AVATARS),
    };
    const plan = pick(PLANS);
    const status = i < 4 ? "expired" : i < 8 ? "trial" : i < 10 ? "suspended" : "active";
    const branchCount = plan.id === "starter" ? 1 : plan.id === "growth" ? rint(1, 3) : rint(2, 6);
    const branches = Array.from({ length: branchCount }, (_, b) => ({
      id: id("br"),
      name: b === 0 ? "Main Branch" : `${pick(["GRA", "Market", "Mile 2", "Wuse", "Sabo", "Garki"])} Branch`,
      location: pick(LOCATIONS),
      staffCount: rint(1, 5),
      lastSync: daysAgo(rint(0, 5)),
    }));
    const staff = Array.from({ length: rint(1, 6) }, () => ({
      id: id("stf"),
      name: fullName(),
      role: pick(["Cashier", "Manager", "Sales Rep", "Stock Keeper"]),
      branch: branches[0].name,
      lastLogin: daysAgo(rint(0, 14)),
    }));
    const syncStatus = pick(SYNC_STATUSES);
    shops.push({
      id: id("shp"),
      name: SHOP_NAMES[i % SHOP_NAMES.length],
      owner,
      branches,
      staff,
      plan: plan.id,
      planName: plan.name,
      planPrice: plan.price,
      status,
      location: pick(LOCATIONS),
      language: pick(LANGUAGES),
      locationRestricted: rand() > 0.7,
      createdAt: daysAgo(rint(2, 240)),
      lastLogin: daysAgo(rint(0, 30)),
      lastSync: daysAgo(rint(0, 6)),
      devices: rint(1, 4),
      mrr: status === "active" || status === "trial" ? plan.price : 0,
      renewsAt: status === "expired" ? daysAgo(rint(1, 12)) : daysFromNow(rint(1, 60)),
      syncStatus,
      pendingQueue: syncStatus === "healthy" ? rint(0, 2) : rint(5, 40),
      failedQueue: syncStatus === "failed" ? rint(3, 18) : 0,
      lastError: syncStatus === "failed" ? "Inventory delta sync timeout (502)" : null,
      acquiredVia: rand() > 0.55 ? "referral" : rand() > 0.5 ? "agent" : "organic",
      notes: rand() > 0.7 ? "Owner requested onboarding call next week." : "",
      featuresUsed: choice(["inventory", "debts", "analytics", "assistant", "multi-branch", "staff", "notifications"], rint(3, 6)),
      engagementScore: rint(20, 98),
    });
  }
  return shops;
}

function buildPayments(shops) {
  const methods = ["Bank Transfer", "Card", "USSD", "Cash", "Manual"];
  const statuses = ["Successful", "Successful", "Successful", "Pending", "Failed", "Reversed", "Manually confirmed"];
  const out = [];
  shops.forEach((s) => {
    const count = rint(1, 6);
    for (let i = 0; i < count; i++) {
      out.push({
        id: id("pay"),
        shopId: s.id,
        shopName: s.name,
        amount: s.planPrice,
        plan: s.planName,
        method: pick(methods),
        status: pick(statuses),
        reference: `TRX${rint(100000, 999999)}`,
        createdAt: daysAgo(rint(0, 120)),
      });
    }
  });
  return out.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
}

function buildAgents() {
  return Array.from({ length: 8 }, (_, i) => ({
    id: id("agt"),
    name: fullName(),
    avatar: pick(AVATARS),
    territory: TERRITORIES[i % TERRITORIES.length],
    referralCode: `${pick(NIGERIAN_FIRST_NAMES).slice(0, 3).toUpperCase()}${rint(100, 999)}`,
    shopsAcquired: rint(3, 28),
    demosCompleted: rint(5, 40),
    conversion: rint(18, 72),
    revenueGenerated: rint(15000, 380000),
    dailyTarget: 3,
    weeklyAchieved: rint(4, 22),
    activeLeads: rint(2, 14),
  }));
}

function buildLeads(agents) {
  const out = [];
  agents.forEach((a) => {
    const n = rint(3, 8);
    for (let i = 0; i < n; i++) {
      out.push({
        id: id("lead"),
        agentId: a.id,
        agentName: a.name,
        shopName: pick(SHOP_NAMES),
        ownerName: fullName(),
        phone: phone(),
        location: pick(LOCATIONS),
        status: pick(LEAD_STATUSES),
        followUpDate: daysFromNow(rint(-3, 14)),
        notes: pick([
          "Demo went well — needs to discuss with partner.",
          "Wants to see analytics module live.",
          "Will pay after restocking next week.",
          "Concerned about offline reliability.",
          "Asked for ₦3,000 plan demo.",
          "",
        ]),
        createdAt: daysAgo(rint(0, 45)),
      });
    }
  });
  return out;
}

function buildReferrals(shops, agents) {
  const referred = shops.filter((s) => s.acquiredVia === "referral" || s.acquiredVia === "agent");
  return referred.map((s) => {
    const isAgent = s.acquiredVia === "agent";
    const ref = isAgent ? pick(agents) : { id: id("ref"), name: fullName(), code: `REF${rint(100, 999)}`, avatar: pick(AVATARS) };
    const converted = s.status === "active";
    const commission = converted ? Math.round(s.planPrice * 0.25) : 0;
    return {
      id: id("rf"),
      shopId: s.id,
      shopName: s.name,
      referrerId: ref.id,
      referrerName: ref.name,
      referrerCode: ref.referralCode || ref.code,
      referrerType: isAgent ? "Field Agent" : "Customer",
      avatar: ref.avatar,
      signedUpAt: s.createdAt,
      converted,
      convertedAt: converted ? daysAgo(rint(0, 60)) : null,
      commission,
      rewardStatus: !converted ? "pending" : pick(["paid", "approved", "pending", "approved"]),
      fraudFlag: rand() > 0.92,
    };
  });
}

function buildTickets(shops) {
  return Array.from({ length: 24 }, () => {
    const s = pick(shops);
    return {
      id: id("tkt"),
      shopId: s.id,
      shopName: s.name,
      ownerName: s.owner.name,
      contact: s.owner.phone,
      category: pick(TICKET_CATEGORIES),
      priority: pick(TICKET_PRIORITIES),
      status: pick(TICKET_STATUSES),
      subject: pick([
        "Sync failing repeatedly after update",
        "Payment didn't reflect on dashboard",
        "Owner cannot log in on new phone",
        "Staff account locked out",
        "Analytics showing zero sales",
        "Notification not delivered",
        "Branch transfer not syncing",
        "Inventory count mismatch",
      ]),
      assignee: pick(["Adaeze O.", "Tunde A.", "Halima B.", "Unassigned"]),
      createdAt: daysAgo(rint(0, 14)),
      slaHours: rint(2, 48),
      escalated: rand() > 0.85,
      thread: [
        { from: "shop", text: "Hi, we noticed an issue today.", at: daysAgo(rint(1, 14)) },
        { from: "admin", text: "Thanks — we're looking into it now.", at: daysAgo(rint(0, 6)) },
      ],
    };
  });
}

function buildNotifications() {
  return Array.from({ length: 12 }, (_, i) => ({
    id: id("ntf"),
    title: pick([
      "Subscription renewal in 3 days",
      "New feature: WhatsApp share for receipts",
      "Sync improvements rolled out",
      "Refer 3 shops, earn ₦5,000",
      "Reminder: complete your shop profile",
    ]),
    channel: pick(["push", "sms", "email", "whatsapp"]),
    audience: pick(["All shops", "Trial shops", "Expired shops", "Top performers", "Inactive 14d+"]),
    sentAt: daysAgo(i),
    delivered: rint(40, 9800),
    opened: rint(20, 7600),
    failed: rint(0, 80),
    status: pick(["Sent", "Sent", "Sent", "Queued"]),
  }));
}

function buildAdminUsers() {
  const roles = ["Super Admin", "Operations Manager", "Support Agent", "Sales Manager", "Field Agent", "Finance Admin", "Product Admin"];
  return roles.map((r, i) => ({
    id: id("adm"),
    name: fullName(),
    email: `${r.toLowerCase().replace(/\s/g, ".")}@company.ng`,
    role: r,
    avatar: pick(AVATARS),
    lastLogin: daysAgo(rint(0, 5)),
    status: i === 0 ? "active" : pick(["active", "active", "active", "invited"]),
    twoFactor: rand() > 0.4,
  }));
}

function buildAuditLogs(shops, admins) {
  const actions = [
    "logged in", "suspended shop", "reactivated shop", "confirmed payment",
    "extended subscription", "approved referral reward", "exported payments CSV",
    "sent announcement", "reset owner access", "updated plan limits",
    "marked subscription paid", "rejected referral reward", "created admin user",
  ];
  return Array.from({ length: 30 }, () => {
    const a = pick(admins);
    return {
      id: id("log"),
      adminId: a.id,
      adminName: a.name,
      role: a.role,
      action: pick(actions),
      target: pick(shops).name,
      ip: `102.${rint(10, 250)}.${rint(0, 255)}.${rint(0, 255)}`,
      device: pick(["Chrome / macOS", "Chrome / Windows", "Safari / iOS", "Firefox / Linux"]),
      at: daysAgo(rint(0, 21)),
      sensitive: rand() > 0.65,
    };
  });
}

const _shops = buildShops();
const _payments = buildPayments(_shops);
const _agents = buildAgents();
const _leads = buildLeads(_agents);
const _referrals = buildReferrals(_shops, _agents);
const _tickets = buildTickets(_shops);
const _notifications = buildNotifications();
const _admins = buildAdminUsers();
const _audit = buildAuditLogs(_shops, _admins);

export const MOCK = {
  shops: _shops,
  payments: _payments,
  agents: _agents,
  leads: _leads,
  referrals: _referrals,
  tickets: _tickets,
  notifications: _notifications,
  admins: _admins,
  audit: _audit,
  plans: PLANS,
};

export const CONSTANTS = {
  LEAD_STATUSES,
  TICKET_CATEGORIES,
  TICKET_PRIORITIES,
  TICKET_STATUSES,
  TERRITORIES,
  LANGUAGES,
  AVATARS,
};

export const CURRENCIES = [
  { code: "NGN", symbol: "₦", name: "Nigerian Naira", rate: 1 },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi", rate: 0.0093 },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling", rate: 0.085 },
  { code: "ZAR", symbol: "R", name: "South African Rand", rate: 0.012 },
  { code: "USD", symbol: "$", name: "US Dollar", rate: 0.00065 },
];
